export const defaultSections = [
  {
    id: 1,
    title: "വ്യക്തി വിവരങ്ങള്‍",
    fields: [
      { id: 1, label: "മുഴുവന്‍ പേര്", value: "പേര് എഴുതുക" },
      { id: 2, label: "ജനന തിയതി", value: "ജനന തിയതി എഴുതുക" },
      { id: 3, label: "നിറം", value: "നിങ്ങളുടെ നിറം ചേര്‍ക്കുക" },
      { id: 4, label: "വിദ്യാഭ്യാസം", value: "നിങ്ങളുടെ വിദ്യാഭ്യാസം എഴുതുക" },
      { id: 5, label: "ജോലി", value: "നിങ്ങളുടെ തൊഴില്‍ എഴുതുക" },
      { id: 6, label: "വരുമാനം", value: "നിങ്ങളുടെ വരുമാനം എഴുതുക" },
      { id: 7, label: "ഉയരം", value: "ഉയരം ചേര്‍ക്കുക" }
    ]
  },
  {
    id: 2,
    title: "കുടുംബ വിവരങ്ങള്‍",
    fields: [
      { id: 8, label: "പിതാവിന്റെ പേര്", value: "അച്ഛന്റെ പേര് എഴുതുക" },
      { id: 9, label: "പിതാവിന്റെ ജോലി", value: "അച്ഛന്റെ ജോലി എഴുതുക" },
      { id: 10, label: "മാതാവിന്റെ പേര്", value: "അമ്മയുടെ പേര് എഴുതുക" },
      { id: 11, label: "മാതാവിന്റെ ജോലി", value: "അമ്മയുടെ ജോലി എഴുതുക" }
    ]
  },
  {
    id: 3,
    title: "ബന്ധപ്പെടാനുള്ള വിവരങ്ങള്‍",
    fields: [
      { id: 12, label: "മുഴുവന്‍ പേര്", value: "പേര് എഴുതുക" },
      { id: 13, label: "ബന്ധപ്പെടാനുള്ള നമ്പര്‍", value: "ബന്ധപ്പെടാനുള്ള നമ്പര്‍ ചേര്‍ക്" },
      { id: 14, label: "താമസ സ്ഥലം", value: "താമസ സ്ഥലം ചേര്‍ക്" }
    ]
  }
];




